export var ctaTextMaxWidth = '_1JM6a';